module.exports = __webpack_public_path__ + "img/tip2-small.f0901d0e.png";